<template>
  <div>
    <div v-if="playerIsGM">
      <p>∾∾∾∾</br>Submit Monster Initiative Below</br>∾∾∾∾</p>
      <h1>Bad Guys</h1>
      <hr class="line"/><br/>
      <div class="villianDiv" v-for="(villian, index) in presentVillians" :key="index">
        <div>
          <div class="input-field inline" v-if="villian.isPresent">
            <input 
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="2"
              class="validate initiative"
              v-model="villian.initiative"
              placeholder="0"
              ref="villianInitiativeInput"
              @click="selectVillianInitiative(villian)"
              @blur="$emit('entity-update', villian, 'initiative')"
              >
            <span class="helper-text" data-error="wrong" data-success="good job">initiativeeeeuh</span>
            </div>
        </div>
        <div class="villianDescriptor" >
          <h4>{{ villian.name }} </h4>
          <br/>
          <div class="input-field inline">
            <input type="checkbox" name="isPresent" v-model="villian.isPresent" class="filled-in" @click="$emit('update-presence', villian, false)">
            <span style="color: rgba(128,128,128,0.5)" @click="$emit('update-presence', villian, false)"><em>Present</em></span>
            <button type="submit" name="action" @click="createMinion(villian)">Add Minion</button>
            <br>
            <input type="text" class="battleId">

          </div>
        </div>
      </div>
      <div class="villianDiv notPresent" v-for="villian in absentVillians" :key="villian.id">
        <div>
        </div>
        <div class="villianDescriptor" >
          <h4>{{ villian.name }}</h4>
          <br/>
          <div class="input-field inline">
            <input type="checkbox" name="isPresent" v-model="villian.isPresent" class="filled-in" @click="$emit('update-presence', villian, false)">
            <span style="color: rgba(128,128,128,0.5)" @click="$emit('update-presence', villian, false)"><em>Present</em></span>
          </div>
          <br/>
          <br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EntityList from '@/components/EntityList'
import Minion from '@/components/Minion'

export default {
  name: 'LoadingRound',
  components: { EntityList },
  props: [
    'entitiesHaveLoaded',
    'scenarioMonsters',
    'scenarioBosses',
    'deleteEntity',
    'toggleActivation',
    'playerIsGM',
    'playerCharacter',
    ],
  data () {
    return {
      pageName: 'LoadingRound',
      focusedEntity: {},
      codeIsChangingSelection: false
    }
  },
  methods: {
    togglePresence(entity) {
      this.$emit('toggle-presence', entity)
    },
    selectVillianInitiative(villian) {
      this.focusedEntity = villian
    },
    letsGOOO(){
      this.$router.push({ name: 'TurnOrder' })
    },
    createMinion(villian){
      console.log(villian.name)
      // let newMinion = {name: villian.name, battleId, hp}
      // this.minions.push(villian)
      // console.log(this.minions,this.minions.length)
    }
  },
  computed: {
    scenarioVillians() {
      return [...this.scenarioMonsters, ...this.scenarioBosses]
    },
    presentVillians() {
      let pvs = this.scenarioVillians.filter(entity => entity.isPresent)
      pvs.forEach(entity => {entity.next = entity})
      let len = pvs.length
      pvs.forEach((entity, index, arr) => {
        if (len-1 > index) {
          entity.next = arr[index+1]
          entity.nextIndex = index+1
        } else {
          entity.next = entity
          entity.nextIndex = index
        }
      });
      return pvs
    },
    absentVillians() {
      return this.scenarioVillians.filter(entity => !entity.isPresent)
    },
    areWeReady() {
      return true
    }
  },
  watch: {
    'focusedEntity.initiative': function(newVal, oldVal) {
      console.log("focusedEntity.initiative changed:", newVal, oldVal)
      if (newVal.length > 1 && oldVal.length < 2) {
        this.$refs.villianInitiativeInput[this.focusedEntity.nextIndex].focus()
        this.focusedEntity = this.presentVillians[this.focusedEntity.nextIndex]

      }
    },
    playerIsGM: function(newVal, oldVal) {
      if (this.playerIsGM) {
        this.$nextTick(() => {this.$refs.villianInitiativeInput[0].focus()})
        this.focusedEntity = this.presentVillians[0]
      }
    }
  },
}
</script>

<style scoped>
input.initiative {
  font-size: 7em;
  height: 7rem;
  text-align: center;
}
.battleId{
  width: 10px;
}
.buttonDiv{
  display: grid;
  grid-row-gap: 50px;
}
.villianDiv{
  display: grid;
  align-self: center;
  align-items: center;
  margin-left: 10px;
  grid-template-columns: 10rem 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 50px;

}
.banner{
  background: deepskyblue;
  height: 75px;
  width: 80%;
  border: 5px;
}
h1{
  color: red;
}
.line{
  width: 180px;
}
.villianDescriptor{
  text-align: start;
}
h4{
  display: inline;
}
.notPresent{
  color: rgba(38, 166, 154, 0.4);
}
.spaceBelow{
  margin-bottom: 50px;
}
.letsGoButtonContainer{
  display: grid;
  grid-template-columns: 10rem 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 50px;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoadingRound.vue